import Cash from '@/components/order/elements/payments/static/Cash.vue'
import CreditCard from '@/components/order/elements/payments/static/CreditCard.vue'
import GiftCard from '@/components/order/elements/payments/static/GiftCard.vue'
import GiftCardOther from '@/components/order/elements/payments/static/GiftCardOther.vue'
import CustomerCredit from '@/components/order/elements/payments/static/CustomerCredit.vue'
import LoyaltyPoints from '@/components/order/elements/payments/static/LoyaltyPoints.vue'
import Custom from '@/components/order/elements/payments/static/Custom.vue'

export default {
  Cash,
  CreditCard,
  GiftCard,
  GiftCardOther,
  CustomerCredit,
  LoyaltyPoints,
  Custom,
}
